import { composeIO } from 'react-compose-io'
import { tabTransformacaoIO } from './TabTransformacao.IO'
import TabTransformacaoView from './TabTransformacao.View'

export const TabTransformacao = composeIO(TabTransformacaoView, tabTransformacaoIO)
